import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function MarginWaterfallVisual({ title, takeaway, caption }) {
  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption}>
      <svg viewBox="0 0 760 360" role="img" aria-label="Revenue flows through operating costs to operating profit and then through interest, taxes and other items to net income.">
        <rect x="250" y="24" width="260" height="70" rx="8" fill={p.surface} stroke={p.line} />
        <text x="380" y="52" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.muted}>Revenue</text>
        <text x="380" y="80" textAnchor="middle" fontSize="25" fontWeight="900" fill={p.ink}>$1,000M · 100%</text>

        <line x1="380" y1="96" x2="380" y2="130" stroke={p.gold} strokeWidth="3" />
        <path d="M380 136 l-8 -11 h16 z" fill={p.gold} />
        <text x="410" y="120" fontSize="12" fontWeight="800" fill={p.muted}>operating costs</text>

        <rect x="250" y="140" width="260" height="72" rx="8" fill={p.goldWash} stroke={p.gold} />
        <text x="380" y="168" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.muted}>Operating Profit</text>
        <text x="380" y="196" textAnchor="middle" fontSize="24" fontWeight="900" fill={p.ink}>$250M · 25%</text>
        <text x="92" y="182" fontSize="13" fontWeight="850" fill={p.ink}>Operating Margin</text>
        <text x="92" y="204" fontSize="12" fontWeight="750" fill={p.muted}>Operating performance</text>
        <path d="M232 184 H250" stroke={p.gold} strokeWidth="2" />

        <line x1="380" y1="214" x2="380" y2="248" stroke={p.gold} strokeWidth="3" />
        <path d="M380 254 l-8 -11 h16 z" fill={p.gold} />
        <text x="410" y="238" fontSize="12" fontWeight="800" fill={p.muted}>interest, taxes, other items</text>

        <rect x="250" y="258" width="260" height="72" rx="8" fill="#fff" stroke={p.line} />
        <text x="380" y="286" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.muted}>Net Income</text>
        <text x="380" y="314" textAnchor="middle" fontSize="24" fontWeight="900" fill={p.ink}>$150M · 15%</text>
        <text x="548" y="300" fontSize="13" fontWeight="850" fill={p.ink}>Net Margin</text>
        <text x="548" y="322" fontSize="12" fontWeight="750" fill={p.muted}>bottom-line profitability</text>
        <path d="M510 302 H540" stroke={p.line} strokeWidth="2" />
      </svg>
    </LearnVisualFrame>
  );
}
